import React from 'react'

/**
 * The square carrying a hub's brand colour: the one badge for a hub wherever it
 * appears (the sidebar, the All hubs page, pinned hubs, permissions), so a hub
 * looks the same everywhere.
 *
 * Since the sidebar surface went neutral, this is where hub identity lives —
 * small enough to stay quiet, saturated enough to tell two hubs apart at a
 * glance. It lives beside the sidebar, which renders it most, but has no
 * sidebar dependencies.
 *
 * The initials take the hub's own text colour (its fontColour), so a pale brand
 * colour still gets readable initials. White is the fallback, for the default
 * navy. Corners and type scale with the size, so a large card's badge is the
 * same shape as the sidebar's.
 */
const HubBadge: React.FC<{
  name: string
  colour?: string
  textColour?: string
  size?: number
  /** Initials to show instead of the name's first two letters. */
  initials?: string
}> = ({ name, colour, textColour, size = 20, initials }) => (
  <span
    className="flex items-center justify-center font-semibold text-on-solid shrink-0"
    style={{
      width: size,
      height: size,
      borderRadius: Math.max(4, Math.round(size * 0.2)),
      background: colour || '#2B3389',
      color: textColour || undefined,
      fontSize: size <= 20 ? 9 : Math.round(size * 0.4)
    }}
    aria-hidden
  >
    {(initials || (name || '?').trim().slice(0, 2)).toUpperCase()}
  </span>
)

export default HubBadge
